var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 502 502",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.081,
    y: 202.904,
    style: {
      fill: "#c6d8f0"
    },
    width: 283.839,
    height: 260.711
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0EFE4"
    },
    points: "29.711,202.904 251,10 472.289,202.904 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.313,
    y: 202.904,
    style: {
      fill: "#F0EFE4"
    },
    width: 56.768,
    height: 260.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.848,
    y: 202.904,
    style: {
      fill: "#F0EFE4"
    },
    width: 56.768,
    height: 260.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.384,
    y: 202.904,
    style: {
      fill: "#F0EFE4"
    },
    width: 56.768,
    height: 260.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.919,
    y: 202.904,
    style: {
      fill: "#F0EFE4"
    },
    width: 56.768,
    height: 260.711
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.237,
    y: 463.616,
    style: {
      fill: "#c6d8f0"
    },
    width: 440.475,
    height: 28.384
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.289,212.904c4.17,0,7.901-2.587,9.364-6.491c1.463-3.905,0.35-8.307-2.793-11.047L257.571,2.462 c-3.766-3.282-9.377-3.282-13.143,0L23.14,195.367c-3.143,2.74-4.256,7.142-2.793,11.047c1.463,3.904,5.194,6.491,9.364,6.491 h12.602v240.711H30.236c-5.522,0-10,4.477-10,10V492c0,5.523,4.478,10,10,10h440.476c5.522,0,10-4.477,10-10v-28.384 c0-5.523-4.478-10-10-10h-11.024V212.904H472.289z M56.4,192.904L251,23.266l194.6,169.639L56.4,192.904L56.4,192.904z M382.919,453.616h-36.768V212.904h36.768V453.616z M307.767,344.285c-5.522,0-10,4.477-10,10v99.331h-8.384V212.904h36.768 v240.711h-8.384v-99.331C317.767,348.762,313.29,344.285,307.767,344.285z M232.616,453.616V212.904h36.768v240.711H232.616z M119.081,453.616V212.904h36.768v240.711H119.081z M175.849,212.904h36.768v240.711h-36.768V212.904z M62.312,212.904h36.769 v240.711h-8.384V312.234c0-5.523-4.478-10-10-10s-10,4.477-10,10v141.381h-8.385C62.312,453.615,62.312,212.904,62.312,212.904z M460.712,473.616V482H40.236v-8.384H460.712z M439.687,453.616h-36.769V212.904h36.769V453.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.836,174.533h57.293c5.522,0,10-4.477,10-10s-4.478-10-10-10h-30.604l96.046-83.726 c4.163-3.629,4.596-9.946,0.967-14.109c-3.629-4.163-9.946-4.595-14.109-0.967L128.265,156.995 c-3.143,2.74-4.256,7.142-2.793,11.047C126.934,171.947,130.666,174.533,134.836,174.533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.411,140.531l36.182,31.541c1.896,1.652,4.236,2.462,6.567,2.462c2.789,0,5.564-1.161,7.542-3.429 c3.629-4.163,3.196-10.48-0.967-14.109l-36.182-31.541c-4.164-3.628-10.479-3.197-14.109,0.967 C319.815,130.585,320.248,136.901,324.411,140.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.004,102.692l15.992,13.941c1.896,1.652,4.236,2.462,6.567,2.462c2.789,0,5.564-1.161,7.542-3.429 c3.629-4.163,3.196-10.48-0.967-14.109l-15.992-13.941c-4.163-3.628-10.479-3.197-14.109,0.967 C276.408,92.745,276.841,99.063,281.004,102.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.385,132.47c0,5.523,4.478,10,10,10h25.23c5.522,0,10-4.477,10-10s-4.478-10-10-10h-25.23 C232.862,122.47,228.385,126.947,228.385,132.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.767,304.877c0-5.523-4.478-10-10-10s-10,4.477-10,10v13.666c0,5.523,4.478,10,10,10s10-4.477,10-10V304.877z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.c146e1f06cda2280807b93881521d4a7.svg";
export { ForwardRef as ReactComponent };